import { getIsHighlighted } from './getIsHighlighted';
import { IPinViewModel } from './getPinViewModel';
import { getGridPin } from '../../../constants/clusterPins/getGridPin';
import { IFeatureProperties } from '../../../types/map';
import { EMapItemZIndex } from '../../mapItemZIndex';

// Порядок наложения пинов раскрытого кластера:
// активный/ховер — выше всех; избранные — выше обычных; внутри уровня порядок задаёт
// zIndex слота (z-order слоёв из дизайна). Избранное — из модели пина: она считается
// один раз на точку входа, чтобы слой и вёрстка не разъехались.
export function getBalloonZIndex(
  properties: IFeatureProperties,
  model: IPinViewModel,
  maxPinsPerCluster: number,
): number {
  if (getIsHighlighted(properties)) {
    return EMapItemZIndex.BALLOON_ACTIVE;
  }

  const base = getGridPin(properties.pinsCount, properties.pinIndex, maxPinsPerCluster)?.zIndex ?? 0;
  const level = model.isFavorite ? EMapItemZIndex.BALLOON_FAVORITE : EMapItemZIndex.BALLOON_DEFAULT;

  return level + base;
}
